// 三岳
// export const BASE_URL = 'http://223.214.6.181:30080';
// export const BASE_URL_WEBSOCKET = 'ws://192.168.10.16:8080';
// export const BASE_URL_VNC = 'http://192.168.10.25:6080/vnc.html';

// // 华自
export const BASE_URL = 'http://172.30.100.201';
// export const BASE_URL_WEBSOCKET = 'ws://172.30.100.202:8081';//内网地址
export const BASE_URL_WEBSOCKET = 'ws://223.214.6.181:30082'; //公网地址
// export const BASE_URL_VNC = 'http://172.30.100.202:9000/vnc.html';//内网地址
export const BASE_URL_VNC = 'http://223.214.6.181:30081/vnc.html'; //公网地址
export const BASE_COMMON_VIDEO_URL = '223.214.6.181:30080'; //视频公网地址
// export const BASE_IP_URL = '192.168.10.64:8080/openUrlTest'; //本地环境ip地址用于视频代理
export const BASE_IP_URL = '/openUrlTest/'; //发布环境ip地址用于视频代理

export const VideoMap = {
  JK001: { name: '高板岩二站厂区及河道', alias: '厂区', id: '28483776900235471', sort: 14 },
  JK002: { name: '高板岩二站厂房尾水', alias: '厂房尾水', id: '28483776900235472', sort: 15 },
  JK003: { name: '高板岩二站堰坝', alias: '堰坝', id: '28483776900235475', sort: 18 },
  JK004: { name: '高板岩二站升压站', alias: '升压站', id: '28483776900235470', sort: 13 },
  JK005: { name: '高板岩二站厂房全景', alias: '厂房全景', id: '28483776900235467', sort: 10 },
  JK006: { name: '高板岩二站厂房右侧', alias: '厂房右侧', id: '28483776900235468', sort: 11 },
  JK007: { name: '高板岩二站厂房左侧', alias: '厂房左侧', id: '28483776900235469', sort: 12 },
  JK008: { name: '', alias: '', id: '' },
  JK009: { name: '后墙1号', alias: '后墙1号', id: '28483776900235491', sort: 34 },
  JK010: { name: '高板岩二站大门口', alias: '大门口', id: '28483776900235493', sort: 36 },
  JK011: { name: '高板岩一站水库', alias: '水库', id: '28483776900235459', sort: 2 },
  JK012: { name: '高板岩一站大坝', alias: '大坝溢流口', id: '28483776900235458', sort: 1 },
  JK013: { name: '高板岩一站大坝', alias: '大坝溢流口', id: '28483776900235458', sort: 1 },
  JK014: { name: '', alias: '', id: '' },
  JK015: { name: '高板岩一站大坝下游', alias: '大坝下游', id: '28483776900235461', sort: 4 },
  JK016: { name: '大坝廊道', alias: '大坝廊道', id: '28483776900235460', sort: 3 },
  JK017: { name: '', alias: '', id: '' },
};
